module.exports = __webpack_public_path__ + "img/MarkAsRead.582202a6.png";